import { Header } from '@/components/DashboardComponents'
import { useLoaderData, useRevalidator } from 'react-router'
import { GenericEmptyListPlaceholder } from '@/DashboardLayout'
import { useMenu } from '@/components/Menu'
import { List, ListItem, ItemColumn } from '@/components/List'
import { useInmemoryStorage } from '@/hooks/useStorage'
import { useModal, Modal, ModalContent, ModalButtons } from '@/components/Modal'
import { FormProvider, FormSubmitProvider } from '@/form/FormProvider'
import { Textbox, Button, Spacing } from '@/form/FormComponents'
import { publicAction } from '@/data/loaders'

export function InternalOrganizations() {
  const revalidator = useRevalidator();
  const organizations = useLoaderData().data.value;

  const [sort, setSort] = useInmemoryStorage("internal_orgs_sort", ["name", -1]);

  const [openNewOrganizationModal] = useModal(function ({ closeModal, setLoading }) {
    function submitCreate({ formatted_data, focusError }) {
      setLoading(true);

      publicAction("createRootOrganization", {
        data: {
          name: formatted_data.name,
          shortname: formatted_data.shortname
        }
      }).then(function() {
        setLoading(false);
        closeModal();
        revalidator.revalidate();
      }).catch(function(error) {
        setLoading(false);
        focusError({name: "name", error: "Something went wrong, please try again."});
        console.error(error);
      })
    }

    return (
      <Modal title="Create root organization">
        <FormProvider onSubmit={submitCreate}>
          <FormSubmitProvider>
            {({handleSubmit}) => (
              <>
                <ModalContent>
                  <Textbox name="name" title="Name" required={true} />
                  <Spacing/>
                  <Textbox name="shortname" title="Short name" required={true} />
                </ModalContent>
                <ModalButtons>
                  <Button text="Cancel" className="hollow" onClick={closeModal}/>
                  <Button text="Submit" className="primary" onClick={handleSubmit}/>
                </ModalButtons>
              </>
            )}
          </FormSubmitProvider>
        </FormProvider>
      </Modal>
    )
  });

  return (
    <>
      <Header title="Organizations">
        <Button text="New organization" icon="plus" onClick={openNewOrganizationModal}/>
      </Header>
      <div className="dashboard_content_inner nearest_scrollable_container">
        <List fullPage={true} columns={[
          { name: "Name", id: "name", sortable: [{ value: -1, name: "A to Z", arrow: "up", default: true }, { value: 1, name: "Z to A", arrow: "down" }] },
        ]} sort={sort} setSort={setSort} menu={true}>
          {[...organizations].sort((a, b) => {
            if (sort[0] === "name") {
              return sort[1] === -1 ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
            }
            return 0;
          }).map((org) => <OrganizationItem key={org._id} organization={org}/>)}
        </List>
        {organizations.length === 0 && <GenericEmptyListPlaceholder text="No organizations"/>}
      </div>
    </>
  )
}

function OrganizationItem({ organization }) {
  const menu = useMenu({
    menuItems: []
  });

  return (
    <ListItem icon="domain" onClick={() => { window.open("https://app.sapientclinician.com/organizations/" + organization._id, "_blank") }}>
      <ItemColumn>{organization.name}</ItemColumn>
    </ListItem>
  )
}
